import { AbstractModel, JsonObject, JsonProperty } from 'projects/core/src/public-api';
import { ShortObject } from './short-json-object';

@JsonObject('model.shortProject')
export class ShortProject extends ShortObject {
    @JsonProperty(String, 'number')
    number?: string;

  @JsonProperty(Boolean, 'fromTimesheet')
  fromTimesheet?: boolean;

}

